module.exports = __webpack_public_path__ + "static/media/mech2.0ad168d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mech2.jpg
// module id = 5819
// module chunks = 0